
    const html = "<div> <ul class=list-unstyled ng-if=trTypesToggle.types.length> <li class=form-group ng-repeat=\"type in ::trTypesToggle.types\"> <label tr-switch tr-switch-side=left> <input type=checkbox ng-model=trTypesToggle.toggles[type.id] ng-change=trTypesToggle.onToggleChange() /> {{::type.label}} </label> </li> </ul> </div> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('/modules/search/views/directives/tr-types-toggle.client.view.html', html);
    }]);
    module.exports = '/modules/search/views/directives/tr-types-toggle.client.view.html';
  